export enum CoinflowWithdrawState {
  IDLE = 'IDLE',
  FUNDING_ROOT_WALLET = 'FUNDING_ROOT_WALLET',
  READY_FOR_WITHDRAWAL = 'READY_FOR_WITHDRAWAL',
  WITHDRAWING = 'WITHDRAWING',
  CANCELED = 'CANCELED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export enum WithdrawMethod {
  COINFLOW = 'COINFLOW',
  MANUAL_TRANSFER = 'MANUAL_TRANSFER'
}
